import { UseFormRegisterReturn } from 'react-hook-form'
import { AlertErrorCircle } from '@/assets/icons'

interface FloatLabelFormTextareaProps {
  label: string
  id: string
  required?: boolean
  error?: string
  registration: UseFormRegisterReturn
  rows?: number
}

/**
 * Float Label Form Textarea
 *
 * A textarea field with floating label support.
 *
 * UX Behavior:
 * - Label is top-aligned by default, acting as a placeholder
 * - Label floats and shrinks when the field is focused or when a value is present
 */
export default function FloatLabelFormTextarea(props: FloatLabelFormTextareaProps) {
  const { label, id, required, error, registration, rows = 5 } = props
  return (
    <div className="flex flex-col gap-1">
      <div className="float-label">
        <textarea
          className={`w-full rounded border-0 ring-1 ring-inset focus:ring-inset focus:outline-none ${
            error ? 'border-red-400 focus:border-red-400' : 'ring-brand-neutral-400 focus:ring-brand-400'
          } resize-none`}
          id={id}
          placeholder=" " // required to activate :placeholder-shown - without it, the label won't float up when the input has a value
          rows={rows}
          aria-invalid={!!error}
          aria-required={required}
          {...registration}
        />
        <label htmlFor={id} className="text-brand-neutral-600">
          {label}
          {required && <span className="text-red-700 ml-[2px]">*</span>}
        </label>
        {error && (
          <p className="p-2 mt-1 flex items-center gap-1 text-xs text-red-800 rounded bg-red-50">
            <AlertErrorCircle className="shrink-0 w-3.5 h-3.5" />
            {error}
          </p>
        )}
      </div>
    </div>
  )
}
